(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/triss-subscription/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/triss-subscription/assets/javascripts/init.js');
"use strict";


const baseUrl = svs.core.data.baseUrl;
const {
  PlayerRouter
} = svs.app.ReactRouter;
const Route = svs.app.ReactRouter.Route;
const Form = svs.ticketSubscription.Form;
const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  Article,
  Widget
} = svs.trissSubscription;
const FallbackHeader = () => React.createElement("div", {
  className: "f-content margin-top-2"
}, React.createElement("h1", {
  className: "f-center"
}, "B\xF6rja prenumerera p\xE5 Triss"));
const Router = React.createElement(PlayerRouter, {
  basename: baseUrl,
  withRouter: true
}, React.createElement(Route, {
  component: _ref => {
    let {
      history
    } = _ref;
    return React.createElement(React.Fragment, null, React.createElement(Widget, {
      Fallback: FallbackHeader,
      name: "topWidget"
    }), React.createElement("div", {
      className: "main-content-subscription"
    }, React.createElement("div", {
      className: "f-content margin-2"
    }, React.createElement(Form, {
      numberOfTickets: svs.utils.paramHandler.get({
        key: 'antal'
      }).value,
      onComplete: () => history.push('/tack')
    }))));
  },
  exact: true,
  path: "/"
}), React.createElement(Route, {
  exact: true,
  path: "/tack"
}, React.createElement("div", {
  className: "f-content margin-2"
}, React.createElement("div", {
  className: "main-content-subscription"
}, React.createElement("h1", {
  className: "f-center"
}, "Tack f\xF6r din best\xE4llning"), React.createElement(Grid, null, React.createElement(GridRow, null, React.createElement(GridCol, {
  md: {
    col: 12
  }
}, React.createElement(Widget, {
  Fallback: Article,
  name: "afterBuyWidget"
}))))))));
const container = document.getElementById('reactContainer');
container && ReactDOM.render(Router, document.getElementById('reactContainer'));
setGlobal('svs.trissSubscription.Router', Router);

 })(window);